module.exports = __webpack_public_path__ + "img/main-content-success.18436cda.svg";